import { render } from "./AddToCalendar.vue?vue&type=template&id=efa3064c"
import script from "./AddToCalendar.vue?vue&type=script&lang=js"
export * from "./AddToCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__